module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABQSURBVHgB7ZDRCQAgCEStiRqtjRvlSiiQKFHpswMR9B6HEr0SgDKqcfcCMIEyYUJ64m5g4jTfoSoXCxJgJcNtuO0yBfShJe21N38oKXmTWB21Q25E5MIeMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/upload.png
// module id = a+ha
// module chunks = 36